import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { GetTableFooter } from '../../../_component/tableFooter';

type orderIsParam = {
  orderIs: string;
};

export function AdminOrderList(props: RouteComponentProps) {
  const history = useHistory();
  const [items, setItems] = useState<any[]>([]);
  const [searchState, setSearchState] = useState<string>('');
  const [meta, setMeta] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [payState, setPayState] = useState<string>('');
  const [orderCode, setOrderCode] = useState<string>('');
  const [jumunCode, setJumunCode] = useState<string>('');
  const dispatch = useDispatch();
  const { match } = props;
  const { orderIs } = match.params as orderIsParam;

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (orderIs !== 'all') {
      setSearchState(orderIs);
      getSearchOrderState();
    }
  }, []);

  useEffect(() => {
    getOrder();
  }, [currentPage, searchState, orderCode, jumunCode]);

  // 주문내역 상태 변경 Param
  const param = {
    payState,
  };

  // 주문내역 조회 API 호출
  const getOrder = async () => {
    if (orderCode !== '') {
      patchOrderState();
      return;
    }
    if (searchState === '') {
      await server
        .getOrderList(currentPage, 10)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .searchOrderState(searchState, currentPage, 10)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 주문내역 조회 API 호출 (대쉬보드 링크로 이동했을 경우)
  const getSearchOrderState = async () => {
    await server
      .searchOrderState(orderIs, currentPage, 10)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload.items);
          setMeta(payload.meta);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문내역 상태 변경 API 호출
  const patchOrderState = async () => {
    await server
      .patchOrderState(orderCode, jumunCode, param)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '해당 주문의 상태가 변경되었습니다.' }));
          setPayState('');
          setOrderCode('');
          setJumunCode('');
          window.location.replace('/admin/sale/order-list/all');
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문내역 상태 검색 체크박스
  function createTableSelectBox() {
    return (
      <div className="table-header">
        <div className="search">
          <div className="selectbox">
            <select
              name=""
              id=""
              onChange={(dom) => {
                setSearchState(dom.target.value);
                setOrderCode('');
                setJumunCode('');
              }}
            >
              <option value="">전체</option>
              <option value="입금대기">입금대기</option>
              <option value="입금확인중">입금확인중</option>
              <option value="입금완료">입금완료</option>
              <option value="결제완료">결제완료</option>
              <option value="출고준비">출고준비</option>
              <option value="출고완료">출고완료</option>
              <option value="환불">환불</option>
              <option value="주문취소">주문취소</option>
            </select>
          </div>
        </div>
        <span>※ 특정 주문의 상태를 변경할 시, 페이지가 자동으로 새로고침됩니다.</span>
      </div>
    );
  }

  // 테이블 헤더
  function createTableHeader() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="order-information">주문일자 및 코드</li>
          <li className="book-title">상품명</li>
          <li className="quantity">수량</li>
          <li className="price">금액</li>
          <li className="user-name">주문자명</li>
          <li className="phone">주문자 연락처</li>
          <li className="payment">결제방법</li>
          <li className="date">입금(예정)일</li>
        </ul>
        {orderListRow}
      </div>
    );
  }

  // 데이터값 불러오기
  const orderListRow = items?.map((item: any) => (
    <ul className="row" key={item.id}>
      <li className="order-information">
        <span className="order-id">{item.orderCode}</span>
        <span className="order-date">{new Date(item.sDate).toLocaleDateString()}</span>
      </li>
      <li className="book-title">{item.bookName}</li>
      <li className="quantity">{Number(item.orderQty).toLocaleString()}</li>
      <li className="price">
        {Number(Number(item.bookPrice) * Number(item.orderQty)).toLocaleString()}
      </li>
      <li className="user-name">{item.purchaserName}</li>
      <li className="phone">{item.purchaserPhone}</li>
      <li className="payment">
        <span>{item.paymentOption}</span>
        <span>{item.payer}</span>
      </li>
      <li className="date">{new Date(item.paymentDate).toLocaleDateString()}</li>
      <ul className="ship-to">
        <li className="user-name">{item.receiverName}</li>
        <li className="phone">{item.receiverPhone}</li>
        <li className="address">{item.receiverAddr}</li>
        <li className="status">
          <div className="selectbox">
            <select
              name=""
              id=""
              defaultValue={item.payState}
              onChange={(event) => {
                setPayState(event.target.value);
                setOrderCode(item.orderCode);
                setJumunCode(item.jumunCode);
              }}
            >
              <option value="입금대기">{payState === '입금대기'}입금대기</option>
              <option value="입금확인중">{payState === '입금확인중'}입금확인중</option>
              <option value="입금완료">{payState === '입금완료'}입금완료</option>
              <option value="결제완료">{payState === '결제완료'}결제완료</option>
              <option value="출고준비">{payState === '출고준비'}출고준비</option>
              <option value="출고완료">{payState === '출고완료'}출고완료</option>
              <option value="환불">{payState === '환불'}환불</option>
              <option value="주문취소">{payState === '주문취소'}주문취소</option>
            </select>
          </div>
        </li>
      </ul>
      <div className="memo">{item.etc}</div>
    </ul>
  ));

  // 테이블 하단 버튼 (미사용)
  const onClick = () => {};

  // AdminOrderList 리턴값
  return (
    <main className="wrapper list-order">
      <div className="title">
        <h1>주문 조회</h1>
        {/* <div className="buttons">
          <button type="button">엑셀파일로 저장</button>
        </div> */}
      </div>
      <div className="content">
        {createTableSelectBox()}
        {createTableHeader()}
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '',
          onClick,
          false
        )}
      </div>
    </main>
  );
}
